import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6508f8fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6508f8fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508f8fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6508f8fa')) {
      api.createRecord('6508f8fa', component.options)
    } else {
      api.reload('6508f8fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6508f8fa&scoped=true", function () {
      api.rerender('6508f8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/formConfig/index.vue"
export default component.exports